import {APPROVE_RELEASE_UNEP} from "../../../../enums/Profile/profile";

export const createCertificateRequestInfoAction = (data) => {
    return {
        type:APPROVE_RELEASE_UNEP,
        payload:data,
    };
};
